import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LoginService } from '../../services/login/login.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ToastrService } from 'ngx-toastr';
import { Authenticate } from '../../models/authenticate';

@Component({
  selector: 'app-claim-filing',
  templateUrl: './claim-filing.html',
  styleUrls: ['./claim-filing.css'],
  imports: [RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, BsDatepickerModule],
})
export class ClaimFiling {
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
